import React from "react";
import useMightyMouse from "react-hook-mighty-mouse";
import ReactTypingEffect from "react-typing-effect";
import Topnav from "../components/Topnav";
import BottomNav from "../components/BottomNav";
// import owiwi from "../images/owiwi.svg";
// tool for styling
import styled from "styled-components";
import { textRegular } from "../components/GlobalStyle";
import leftEyeBrow from "../images/LeftEyeBrow.svg";
import rightEyeBrow from "../images/RightEyeBrow.svg";
import Nose from "../images/Nose.svg";
import { Link } from "react-router-dom";

function Homepage() {
  const {
    selectedElement: {
      isHover,
      position: { x, y, angle },
    },
  } = useMightyMouse(true, "hit-him-up");

  // eye tracking functions --start
  const { position } = useMightyMouse();
  const {
    selectedElement: {
      position: { angle: angleLeftEye },
    },
  } = useMightyMouse(true, "left-eye", { x: 0, y: 0 });
  const {
    selectedElement: {
      position: { angle: angleRightEye },
    },
  } = useMightyMouse(true, "right-eye", { x: 0, y: 0 });

  const rotateLeftEye = `rotate(${-angleLeftEye}deg)`;
  const rotateRightEye = `rotate(${-angleRightEye}deg)`;
  // eye tracking functions --end

  return (
    <HomepageStyle>
      <div>
        <Topnav />
        <Link to={"/works"} className="touch folio-button">
          ! open work folio !
        </Link>
        <div className="owiwi">
          <div className="image">
            {/* image  */}
            {/* brows --start  */}
            <div className="brows center">
              <img src={leftEyeBrow} alt="" />
              <img src={rightEyeBrow} alt="" />
            </div>
            {/* brows --end */}

            {/* eyes --start  */}
            <div className="eyes center">
              <div
                id="right-eye"
                className="eye"
                style={{
                  transform: rotateRightEye,
                  background: isHover ? "black" : "",
                }}
              >
                <div className="iris__right iris"></div>
              </div>
              <div
                className="eye"
                id="left-eye"
                style={{
                  transform: rotateLeftEye,
                  background: isHover ? "black" : "",
                }}
              >
                <div className="iris__left iris"></div>
              </div>
            </div>
            {/* eyes --end */}
            {/* nose--start  */}
            <div className="center">
              <img src={Nose} alt="" />
            </div>
            {/* nose --end */}
            {/* image  */}
          </div>
          <div className="center">
            <div>
              HEY! I’M <span className="special">OWIWI</span>, SAM’S CYBORG OWL
            </div>
          </div>

          <div className="center">
            <div
              style={{
                maxWidth: "600px",
                textAlign: "center",
              }}
            >
              This is the lobby. You're
              {isHover ? (
                <> at </>
              ) : (
                <>
                  {" "}
                  x{(x && x.toFixed(0)) - 32} y{(y && y.toFixed(0)) - 12} away
                  from{" "}
                </>
              )}
              his door.
            </div>
          </div>

          <div className="center">
            <Link to={"/works"} className="to-works">
              <div id="hit-him-up">!Knock Knock!</div>
            </Link>
          </div>
        </div>
        <div className="bottom">
          <BottomNav />
        </div>
      </div>
    </HomepageStyle>
  );
}
export default Homepage;

// styling
export const HomepageStyle = styled.div`
  @media (hover: none) {
    .touch {
      display: block !important;
    }
    .time,
    .pages,
    .mail,
    .owiwi,
    .coins,
    .job-roles {
      display: none !important;
    }
    .folio-button {
      position: absolute;
      border: 1px solid #cccccc;
      padding: 18px 24px;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  position: relative;
  ${textRegular}
  height: 100vh;

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .touch {
    display: none;
  }
  .image {
    margin-top: 20vh;
    margin-bottom: 10px;
    position: relative;
  }

  .special {
    font-style: italic;
    color: #fac72c;
  }
  .brows {
    gap: 20px;
    position: absolute;
    margin-top: -55px;
    z-index: 1;
    width: 100%;
  }
  .eyes {
    gap: 40px;
    z-index: -1;
    margin-left: -20px;
  }
  .eye {
    position: relative;
    height: 9rem;
    width: 9rem;
    border-radius: 50%;
  }
  #left-eye {
    background: #710c04;
  }
  #right-eye {
    background: black;
  }
  .iris {
    border-radius: 50%;
    position: absolute;
    width: 9rem;
    height: 9rem;
    left: 10px;
    top: 2px;
    border: 4px solid #cccccc;
    background: radial-gradient(
      39.51% 39.51% at 50% 50%,
      #fac72c 0%,
      rgba(250, 199, 44, 0) 100%
    );
  }
  .iris__left {
    background: radial-gradient(
      39.51% 39.51% at 50% 50%,
      #fac72c 0%,
      rgba(250, 199, 44, 0) 100%
    );
  }

  .to-works {
    color: inherit;
  }
  @media only screen and (max-width: 600px) {
    .name-and-title {
      font-size: 1.6rem;
    }
  }
`;
